// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gEw8L","left":"styles_left__DxwGx","title":"styles_title__wgCg2","description":"styles_description__PSAVe","button":"styles_button__QPDoO"};